import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import Login from './login/pc-login';
import zhCN from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd'
import 'moment/locale/zh-cn';
import './css/global.less'
import api from '@/apis/pc/user/user';
import { Provider } from 'react-redux';
import configureStore from 'core/lib/store';
import {traceLog} from "@/utils/log";
import { getParameterByName } from "@/utils/utils";
import VisibilityRangePc from './visibility-range-pc' //缺省页
const store = configureStore();
import GlobalStyle from "./components/global-style/global-style";
import { isQD } from './utils/common';
import 'lxui/src/ui/index.css';
import 'lxybc/src/ui/index.css'
import ChangeThemeLx from 'lxui/src/lib/changeTheme'

if (isQD()) {
  const _open = window.open;
  window.open = (...rest) => {
    if (rest[1]) {
      const [url, isBlank, ...others] = rest;
      _open(url, '_self', ...others);
    } else {
      const url = rest[0];
      _open(url, '_self');
    }
  };
}

let themeType = window.globalBrandToneName || window.theme_style || 'orange';
if (themeType === 'orange') {
  ChangeThemeLx('orange')
} else {
  ChangeThemeLx('blue')
}
ConfigProvider.config({
  theme: {
    primaryColor: '#FC8352',
  },
});
// 记录落地页到main加载的时间
traceLog('mainTime', new Date().valueOf() - Number(localStorage.getItem('crmPageStart')))
function render(){
  ReactDOM.render(
    <ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <GlobalStyle />
        <Login />
      </Provider>
    </ConfigProvider>,
    document.getElementById('traffic-container')
  );
}
function visibilityRangeRender() {
  ReactDOM.render(
    <ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <GlobalStyle />
        <VisibilityRangePc />
      </Provider>
    </ConfigProvider>,
    document.getElementById('traffic-container')
  );
}

// location.href.includes('localhost') ?  window.publicVariablesHub = {
//   "currentUser": {
//       "id": 3001951,
//       "uid": 5620768,
//       "name": "郑福星",
//       "phone": "",
//       "third_userid": "ZhengFuXing",
//       "userToken": "c1ef30a487ff84f5aca9cb556223d4f8"
//   },
//   "currentOrganization": {
//       "id": 3000028,
//       "oid": 2002564,
//       "name": "上海圈商信息科技有限公司"
//   },
//   "currentOEM": {
//       "globalBrandNameI18n": "励销",
//       "businessSourceMarketType": "wxwork",
//       "businessSourceMarketI18n": "企业微信",
//       "globalBrandToneName": "orange"
//   },
//   "apiHosts": {
//       "crm": "https://lixiao-dev.ikcrm.com"
//   }
// } : ''

let crm_platform_type = '';
console.log(crm_platform_type);
const deviceType = getParameterByName("deviceType");
const reg = /[a-zA-Z0-9.]*crm[a-zA-Z0-9-]*.weiwenjia.com/;
let PLAT = JSON.parse(sessionStorage.getItem('PLAT')) || null;
// h5获取url传入token
if(deviceType === 'h5Side') {
  if(!reg.test(window.location.host)){
    crm_platform_type = "wxwork";
  }
} else if (PLAT && PLAT.data) {
  if(!(reg.test(window.location.host) && window.AppConf?.loginType === 'hybrid')){
    crm_platform_type = "wxwork";
  }
}
// if(crm_platform_type == 'wxwork' || window.crm_platform_type == 'wxwork'){ //crm_platform_type == 'wxwork'
//   api.getLoginUser()
//   .then((res)=>{
//     console.log('res: pc=>', res);
//     const isShow = _.get(res,'data.status', true);
//     if(!isShow){
//       visibilityRangeRender()
//     }else{
//       render()
//     }
//   })
//   .catch(()=>{
//     render()
//   })
// }else{
//   render();
// }
render()
